import { render, staticRenderFns } from "./fieldList.vue?vue&type=template&id=5cd9663f&scoped=true"
import script from "./fieldList.vue?vue&type=script&lang=js"
export * from "./fieldList.vue?vue&type=script&lang=js"
import style0 from "./fieldList.vue?vue&type=style&index=0&id=5cd9663f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd9663f",
  null
  
)

export default component.exports